import { defineComponent as _defineComponent } from 'vue'
import Icon from 'JS/components/Icon.vue';
import MegaMenuAutomotiveDepartment from './MegaMenuAutomotiveDepartment.vue';
import MegaMenuDepartment from './MegaMenuDepartment.vue';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { debounce } from 'JS/utilities/debounce';
import { IWebSiteMenu } from 'Src/js/types/Header';


export default /*#__PURE__*/_defineComponent({
  __name: 'MegaMenu',
  props: {
    departments: null
  },
  setup(__props: any) {

const props = __props as {
	departments: IWebSiteMenu[];
}



const activeMenuId = ref<string>("");
const automotiveMenuId: string = "12";
const animalRxMenuId: string = "13";

const setActiveMenuIdDebounced = debounce(300, (newMenuId)=> {
	activeMenuId.value = newMenuId;
});

const automotiveMenuItem = computed(()=> {
	return props.departments.find(x => x.id === automotiveMenuId);
});

const animalRxMenuItem = computed(()=> {
	return props.departments.find(x => x.id === animalRxMenuId);
});

onMounted(()=> {
	const content = document.getElementById('contentWrapper');
	if (!content) return;
	content.classList.add('shadowed');
});

onUnmounted(()=> {
	const content = document.getElementById('contentWrapper');
	if (!content) return;
	content.classList.remove('shadowed');
});

function toggleDepartment(departmentId: string) {
	activeMenuId.value = activeMenuId.value !== departmentId ? departmentId : "";
}

watch(()=> props.departments, (departmentsNew: IWebSiteMenu[]) => {
	if (!departmentsNew?.length) return;

	activeMenuId.value = departmentsNew[0].id;
});



return { __sfc: true,props, activeMenuId, automotiveMenuId, animalRxMenuId, setActiveMenuIdDebounced, automotiveMenuItem, animalRxMenuItem, toggleDepartment, Icon, MegaMenuAutomotiveDepartment, MegaMenuDepartment }
}

})